import React, { useContext, useEffect, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import SingleProperty from "./SingleProperty";
import { useNavigate } from "react-router-dom";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { toast } from "react-toastify";
import LinkedPropertiesPopup from "../../../components/Property/LinkedPropertiesPopup";

const PropertyRow = ({
  data,
  onPropertyAward,
  tanentData,
  loadData,
  user,
  propId,
  openLinkedPopup,
}) => {
  const { _t } = useTranslator();

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [linkedTenantsPopup, setLinkedTenantsPopup] = useState(false);
  const [selectBtn, setSelectBtn] = useState(_t("select") + "...");
  const [preselectedTanents, setPreselectedTanents] = useState([]);
  const [selectedTanents, setSelectedTanents] = useState([]);
  const [saveTanentLoading, setsaveTanentLoading] = useState(false);
  const navigate = useNavigate();
  const landLordContext = useContext(LandLordContext);
  const { saveTanentData } = landLordContext;
  const [tenantChanged, setTenantChanged] = useState(false);

  useEffect(() => {
    console.log(openLinkedPopup, data?._id);
    if (openLinkedPopup) {
      setLinkedTenantsPopup(true);
    }
  }, [openLinkedPopup]);

  useEffect(() => {
    // Preselect tenants when property changes
    if (data?.sharedProfiles) {
      const dataArray = Array.isArray(data.sharedProfiles)
        ? data.sharedProfiles
        : [];

      const updatedData = dataArray.map((item) => {
        const tenant = item?.tenant_id || item?.tenantid;
        return {
          label: tenant?.fname + " " + (tenant?.lname ?? ""),
          value: tenant?._id,
        };
      });

      setPreselectedTanents(updatedData);
      setSelectedTanents(updatedData.map((item) => item.value));
    }
  }, [data?.sharedProfiles, linkedTenantsPopup]);

  const handleNavigateProfile = (assignedProp) => {
    navigate(
      `/profile-property?sharedprofileid=${assignedProp?._id}&step=linked_props`
    );
  };

  useEffect(() => {
    // Update button text whenever selected tenants change
    if (selectedTanents.length > 0) {
      const selectedLabels = tanentData
        .filter((tenant) => selectedTanents.includes(tenant.value))
        .map((tenant) => (
          <span className="placeholder_string">{tenant.label}</span>
        ));

      setSelectBtn(
        selectedLabels.length ? selectedLabels : _t("select") + "..."
      );
    } else {
      setSelectBtn(_t("select") + "...");
    }
  }, [selectedTanents, tanentData]);

  useEffect(() => {
    const originalTenantIds = (preselectedTanents ?? []).map((i) =>
      typeof i === "object" ? i.value : i
    );
    const selectedIds = (selectedTanents ?? []).map((i) =>
      typeof i === "object" ? i.value : i
    );

    const areEqual =
      JSON.stringify([...originalTenantIds].sort()) ===
      JSON.stringify([...selectedIds].sort());

    setTenantChanged(!areEqual);
  }, [selectedTanents, preselectedTanents]);

  const handlePropSelect = (e) => {
    const selectedValues = e.map((val) => val.value);
    setSelectedTanents(selectedValues);
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    const originalTenantIds = preselectedTanents.map((tenant) => tenant.value);

    const add_tanents = selectedTanents.filter(
      (tenantId) => !originalTenantIds.includes(tenantId)
    );
    const rejected_tanents = originalTenantIds.filter(
      (tenantId) => !selectedTanents.includes(tenantId)
    );

    const payload = {
      property_id: data?._id,
      add_tanents,
      rejected_tanents,
    };

    try {
      setsaveTanentLoading(true);
      const response = await saveTanentData(payload);
      if (response?.data?.status === "success") {
        toast.success(response?.data?.msg);
        loadData();
      }
    } catch (error) {
      console.error("Error saving tenants:", error);
    } finally {
      setsaveTanentLoading(false);
    }
  };

  return (
    <>
      <tr className="second-row">
        <td>
          {data?.street} -{" "}
          {Number.isNaN(parseInt(data?.street_number, 10))
            ? "N/A"
            : String(parseInt(data?.street_number, 10))}{" "}
          - {data?.floor_number} - {data?.flat_number}
        </td>
        {user?.isParentLL && (
          <td>{data?.landlord?.fname_companyName ?? "N/A"}</td>
        )}
        <td>{data?.muncipality}</td>
        <td>{data?.postcode}</td>
        <td>
          <div
            id={`divBtnLinkedTenant-${data?._id}`}
            onClick={() => setLinkedTenantsPopup(true)}
            className="d-flex align-items-center bg-[#DBF1CA] cursor-pointer bg_test"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              className="button_iconset"
            >
              <path
                d="M13.5 4.21053C13.5 5.32723 13.0259 6.39819 12.182 7.18782C11.3381 7.97745 10.1935 8.42105 9 8.42105C7.80653 8.42105 6.66193 7.97745 5.81802 7.18782C4.97411 6.39819 4.5 5.32723 4.5 4.21053C4.5 3.09383 4.97411 2.02286 5.81802 1.23323C6.66193 0.443608 7.80653 0 9 0C10.1935 0 11.3381 0.443608 12.182 1.23323C13.0259 2.02286 13.5 3.09383 13.5 4.21053ZM13.1378 11.0558C12.6056 11.0611 12.1095 11.08 11.6775 11.1337C10.9541 11.2253 10.1621 11.4421 9.5085 12.0547C8.85375 12.6663 8.622 13.4074 8.52525 14.0842C8.4375 14.6926 8.4375 15.4358 8.4375 16.2253V16.4063C8.4375 17.1958 8.4375 17.9389 8.52525 18.5474C8.59275 19.0221 8.72775 19.5284 9.02812 20H9C0 20 0 17.8789 0 15.2632C0 12.6474 4.02975 10.5263 9 10.5263C10.4917 10.5263 11.8991 10.7168 13.1378 11.0558Z"
                fill="#253837"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.0625 20C12.2062 20 11.2781 20 10.7021 19.46C10.125 18.9211 10.125 18.0526 10.125 16.3158C10.125 14.579 10.125 13.7105 10.7021 13.1716C11.2781 12.6316 12.2062 12.6316 14.0625 12.6316C15.9187 12.6316 16.8469 12.6316 17.4229 13.1716C18 13.7105 18 14.579 18 16.3158C18 18.0526 18 18.9211 17.4229 19.46C16.8469 20 15.9187 20 14.0625 20ZM16.2765 15.5221C16.3996 15.407 16.4687 15.2508 16.4687 15.0879C16.4687 14.925 16.3996 14.7689 16.2765 14.6537C16.1534 14.5385 15.9865 14.4738 15.8124 14.4738C15.6384 14.4738 15.4715 14.5385 15.3484 14.6537L13.1884 16.6747L12.7766 16.2905C12.7157 16.2335 12.6433 16.1883 12.5637 16.1574C12.4841 16.1266 12.3987 16.1107 12.3126 16.1107C12.2264 16.1107 12.141 16.1266 12.0614 16.1574C11.9818 16.1883 11.9094 16.2335 11.8485 16.2905C11.7876 16.3476 11.7392 16.4153 11.7062 16.4898C11.6733 16.5643 11.6563 16.6441 11.6563 16.7248C11.6563 16.8054 11.6733 16.8852 11.7062 16.9597C11.7392 17.0342 11.7876 17.1019 11.8485 17.159L12.7238 17.9779C12.7847 18.035 12.857 18.0802 12.9366 18.1111C13.0163 18.142 13.1016 18.1579 13.1878 18.1579C13.274 18.1579 13.3594 18.142 13.439 18.1111C13.5186 18.0802 13.591 18.035 13.6519 17.9779L16.2765 15.5221Z"
                fill="#253837"
              />
            </svg>
            <p className="linked_p">{data?.sharedProfiles.length || 0}</p>
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 10.7222L6 6.00001L1 1.27778"
                stroke="#253837"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </td>
        <td>
          <div
            className="cursor-pointer"
            onClick={() => setShowDetailsModal(true)}
          >
            {_t("viewDetails")}{" "}
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 10.7222L6 6.00001L1 1.27778"
                stroke="#253837"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </td>
      </tr>
      <Modal
        show={showDetailsModal}
        className="metermodal"
        centered
        onHide={() => setShowDetailsModal(false)}
      >
        <Modal.Body>
          <SingleProperty
            key={data?._id}
            property={data}
            isParentLL={true}
            onPropertyAward={onPropertyAward}
            tanentData={tanentData}
            loadData={loadData}
            hideModal={(e) => setShowDetailsModal(false)}
            setLinkedTenantsPopup={setLinkedTenantsPopup}
          />
        </Modal.Body>
      </Modal>
      <LinkedPropertiesPopup
        detailsShow={linkedTenantsPopup}
        setDetailsShow={setLinkedTenantsPopup}
        property={data}
        selectBtn={selectBtn}
        tanentData={tanentData}
        preselectedTanents={preselectedTanents}
        handlePropSelect={handlePropSelect}
        handleSaveChanges={handleSaveChanges}
        saveTanentLoading={saveTanentLoading}
        handleNavigateProfile={handleNavigateProfile}
        tenantChanged={tenantChanged}
      />
    </>
  );
};

export default PropertyRow;
